<template>

  <div>
    <div class="main-content container-fluid">
      <div class="row">
        <div class="col-md-12">
          <PageHeader title="Manage Users" subtitle="">
          </PageHeader>

          <Panel class="panel panel-default panel-border-color panel-border-color-primary">
            <div class="row">
              <div class="col-xs-12 xs-p-40">
                <p><strong>Download user CSVs</strong></p>
                <button class="btn btn-primary btn-xl" v-on:click="downloadUsers()" :disabled="saving">Download registered users</button>
                <button class="btn btn-warning btn-xl" v-on:click="downloadSubs()" :disabled="saving">Download newsletter subscribers</button>
              </div>
            </div>            
          </Panel>
        </div><!-- /div -->
      </div><!-- /div -->
    </div><!-- /div -->
  </div><!-- /div -->

</template>

<script>

  import { mapState, mapActions, mapGetters } from 'vuex';
  import Blog from '../../../resources/exportUsers'
  import _ from 'underscore'



  export default {
    components: {
    },

    created() {
      
    },

    methods: {
      downloadUsers() {
        this.saving = true;
        var self = this;

        this.$store.dispatch('exportUsers', {
          callback: function (result) {
            self.saving = false;

            var file = new Blob([result], { type: '.csv' });
            if (window.navigator.msSaveOrOpenBlob) // IE10+
              window.navigator.msSaveOrOpenBlob(file, 'user-export.csv');
            else { // Others
              var a = document.createElement("a"),
                url = URL.createObjectURL(file);
              a.href = url;
              a.download = 'user-export.csv';
              document.body.appendChild(a);
              a.click();
              setTimeout(function () {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
              }, 0);
            }
          }
        });
      },

      downloadSubs() {
        this.saving = true;
        var self = this;

        this.$store.dispatch('exportSubscribers', {
          callback: function (result) {
            self.saving = false;

            var file = new Blob([result], { type: '.csv' });
            if (window.navigator.msSaveOrOpenBlob) // IE10+
              window.navigator.msSaveOrOpenBlob(file, 'newsletter-export.csv');
            else { // Others
              var a = document.createElement("a"),
                url = URL.createObjectURL(file);
              a.href = url;
              a.download = 'newsletter-export.csv';
              document.body.appendChild(a);
              a.click();
              setTimeout(function () {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
              }, 0);
            }
          }
        });
      },
      
    },

    computed: {
      ...mapState([
      ]),

      
    },

    data() {
      return {
        saving: false
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  
</style>



// WEBPACK FOOTER //
// usermanager.vue?3ea76906